import { Home } from 'lucide-react';
import type { PropertyResponse } from '@/shared/api';
import { AccessInfoReveal } from './AccessInfoReveal';
import { PanelCard, FieldGrid, Field } from './PanelCard';
import { ProvenanceTag } from './ProvenanceTag';

function hhmm(t: string | null | undefined): string | null {
  if (!t) return null;
  const [h, m] = t.split(':');
  return h && m ? `${h}:${m}` : null;
}

function addressLine(p: PropertyResponse): string {
  const a = p.address;
  return [a.street, [a.postalCode, a.city].filter(Boolean).join(' '), a.countryCode]
    .filter(Boolean)
    .join(' · ');
}

// Apartment-Stammdaten + gated Zugangsdaten (Tuercode/WLAN-Passwort erst auf Reveal, on-demand).
export function PropertyContextCard({
  property,
  threadId,
  bookingId,
  demo,
}: {
  property: PropertyResponse;
  threadId: string;
  // Traegt der Thread eine eindeutige Buchung, geht der Reveal nie ohne Apartmentbezug los.
  bookingId?: string | null;
  demo?: boolean;
}) {
  return (
    <PanelCard
      icon={Home}
      title="Apartment und Zugang"
      hint="Türcode und WLAN erst auf Abruf"
      trailing={<ProvenanceTag source="internal" />}
    >
      <FieldGrid>
        <Field wide label="Adresse" value={addressLine(property)} />
        <Field
          label="Check-in"
          mono
          value={hhmm(property.checkInTime) ? `ab ${hhmm(property.checkInTime)}` : null}
        />
        <Field
          label="Check-out"
          mono
          value={hhmm(property.checkOutTime) ? `bis ${hhmm(property.checkOutTime)}` : null}
        />
        <Field label="WLAN" value={property.wiFiSsid} />
        {property.emergencyContact && (
          <Field wide label="Notfall-Kontakt" mono value={property.emergencyContact} />
        )}
      </FieldGrid>
      <AccessInfoReveal threadId={threadId} bookingId={bookingId} demo={demo} />
    </PanelCard>
  );
}
